import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";
import NProgress from "nprogress";

import TheContainer from "../components/master/TheContainer.vue";
import Dashboard from "../components/Dashboard.vue";
import Profile from "../components/seller/Profile/Profile";
import NoNetwork from "../components/state/NoConnection.vue";

import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import ForgotPassword from "../views/ForgotPassword.vue";

import Pemberitahuan from "../components/seller/Pemberitahuan/Pemberitahuan.vue";
import UserLog from "../components/seller/Pemberitahuan/UserLog.vue";

import Product from "../components/seller/Product/Product.vue";
import AddProduct from "../components/seller/Product/AddProduct/AddProduct.vue";
import Pesanan from "../components/seller/Pesanan/Pesanan.vue";
import Penagihan from "../components/seller/Penagihan/Penagihan.vue";
import Negoisasi from "../components/seller/Negoisasi/Negoisasi";
import Ekspedisi from "../components/seller/Ekspedisi";
import Komplain from "../components/seller/Komplain/Komplain";
import ChangeOrder from "../components/seller/ChangeOrder/ChangeOrder";

import Chat from "../components/seller/Chat/Chat.vue";

import Review from "../components/seller/Review/Review.vue";

import SemuaPembayaran from "../components/seller/Pembayaran/SemuaPembayaran.vue";
import PembayaranKurangLengkap from "../components/seller/Pembayaran/PembayaranKurangLengkap.vue";
import PembayaranVerifikasi from "../components/seller/Pembayaran/PembayaranVerifikasi.vue";
import PembayaranDiteruskan from "../components/seller/Pembayaran/PembayaranDiteruskan.vue";

//detail
import DetailProduct from "../components/seller/Product/DetailProduct";
import DetailPesanan from "../components/seller/Pesanan/DetailPesanan";
import DetailNegoisasi from "../components/seller/Negoisasi/DetailNegoisasi";
import DetailKomplain from "../components/seller/Komplain/DetailKomplain";
import UserLogDetail from "../components/seller/Pemberitahuan/UserLogDetail.vue";

import $ from "jquery";
Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: {
      name: "Dashboard",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      guest: true,
      title: "Login Seller - SIPLah",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      guest: true,
      title: "Daftar Seller - SIPLah",
    },
  },
  {
    path: "/forgot",
    name: "Lupa Password",
    component: ForgotPassword,
    meta: {
      guest: true,
      title: "Lupa Password Seller - SIPLah",
    },
  },
  {
    path: "/no-network",
    name: "NoNetwork",
    component: NoNetwork,
    meta: {
      auth: true,
      title: "NoNetwork",
    },
  },
  {
    path: "/",
    redirect: "/dashboard",
    name: "Dashboard",
    component: TheContainer,
    meta: {
      auth: true,
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          auth: true,
          title: "Dashboard",
        },
      },
      {
        path: "/chat",
        name: "Chat",
        component: Chat,
        meta: {
          auth: true,
          title: "Chat",
        },
      },
      {
        path: "/review",
        name: "Review",
        component: Review,
        meta: {
          auth: true,
          title: "Review",
        },
      },
      {
        path: "profile",
        name: "profile",
        component: Profile,
        meta: {
          auth: true,
          title: "Profile",
        },
      },
      {
        path: "/pemberitahuan",
        name: "Pemberitahuan",
        component: Pemberitahuan,
        meta: {
          auth: true,
          title: "Pemberitahuan",
        },
      },
      {
        path: "/userlog",
        name: "UserLog",
        component: UserLog,
        meta: {
          auth: true,
          title: "User Log",
        },
      },
      {
        path: "/product",
        name: "Product",
        component: Product,
        meta: {
          auth: true,
          title: "Product",
        },
      },
      {
        path: "/product/detail/:id",
        name: "DetailProduct",
        component: DetailProduct,
        meta: {
          auth: true,
          title: "Detail Product",
        },
      },
      {
        path: "/product/addproduct",
        name: "Add Product",
        component: AddProduct,
        meta: {
          auth: true,
          title: "Add Product",
        },
      },
      {
        path: "/pesanan",
        name: "Pesanan",
        component: Pesanan,
        meta: {
          auth: true,
          title: "Pesanan",
        },
      },
      {
        path: "/penagihan",
        name: "Penagihan",
        component: Penagihan,
        meta: {
          auth: true,
          title: "Penagihan",
        },
      },
      {
        path: "/pembayaran/semuapembayaran",
        name: "SemuaPembayaran",
        component: SemuaPembayaran,
        meta: {
          auth: true,
          title: "Semua Pembayaran",
        },
      },
      {
        path: "/pembayaran/kuranglengkap",
        name: "PembayaranKurangLengkap",
        component: PembayaranKurangLengkap,
        meta: {
          auth: true,
          title: "Pembayaran Kurang Lengkap",
        },
      },
      {
        path: "/pembayaran/verifikasi",
        name: "PembayaranVerifikasi",
        component: PembayaranVerifikasi,
        meta: {
          auth: true,
          title: "Pembayaran Verifikasi",
        },
      },
      {
        path: "/pembayaran/diteruskan",
        name: "PembayaranDiteruskan",
        component: PembayaranDiteruskan,
        meta: {
          auth: true,
          title: "Pembayaran Diteruskan",
        },
      },
      {
        path: "/pesanan/detail/:id",
        name: "DetailPesanan",
        component: DetailPesanan,
        meta: {
          auth: true,
          title: "Detail Pesanan",
        },
      },
      {
        path: "/ekspedisi",
        name: "Ekspedisi",
        component: Ekspedisi,
        meta: {
          auth: true,
          title: "Ekspedisi",
        },
      },
      {
        path: "/negoisasi",
        name: "Negoisasi",
        component: Negoisasi,
        meta: {
          auth: true,
          title: "Negoisasi",
        },
      },
      {
        path: "/negoisasi/detail/:id",
        name: "DetailNegoisasi",
        component: DetailNegoisasi,
        meta: {
          auth: true,
          title: "Detail Negoisasi",
        },
      },
      {
        path: "/komplain",
        name: "Komplain",
        component: Komplain,
        meta: {
          auth: true,
          title: "Komplain",
        },
      },
      {
        path: "/komplain/detail/:id",
        name: "DetailKomplain",
        component: DetailKomplain,
        meta: {
          auth: true,
          title: "Detail Komplain",
        },
      },
      {
        path: "/userlog/user/:id",
        name: "UserLogDetail",
        component: UserLogDetail,
        meta: {
          auth: true,
          title: "User Log Detail",
        },
      },
      {
        path: "/changeorder",
        name: "ChangeOrder",
        component: ChangeOrder,
        meta: {
          auth: true,
          title: "Perubahan Pesanan",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base:
    // process.env.NODE_ENV,

    "/sandbox_seller/",
  scrollBehavior: () => ({ y: 0, behavior: "smooth" }),
  routes,
});

NProgress.configure({
  showSpinner: false,
});

router.afterEach((to) => {
  setTimeout(() => {
    $("html").removeClass("nav-open");
  }, 550);

  //   // var mallName = store.getters.user.name;

  Vue.nextTick(() => {
    const DEFAULT_TITLE = "SIPLah Seller";
    // const mallName = store.getters.user.name;
    document.title =
      // typeof mallName === "undefined"
      //   ? DEFAULT_TITLE + " | Login"
      //   : mallName
      //       .toLowerCase()
      //       .split(" ")
      //       .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      //       .join(" ") +
      //       " | " +
      to.meta.title + " | " + DEFAULT_TITLE || DEFAULT_TITLE;
  });
  setTimeout(() => NProgress.done(), 300);
});

router.beforeResolve((to, from, next) => {
  if (to.path) {
    NProgress.set(0.2);
  }

  next();
});

router.beforeEach((to, from, next) => {
  // let setRoute = localStorage.getItem("lastRoute");

  if (to.matched.some((record) => record.meta.auth)) {
    if (store.getters.isLoggedIn && store.getters.user) {
      NProgress.start();
      // setTimeout(() => {
      next();
      // }, 200);
      return;
    }
    next("/login");
  }

  if (to.matched.some((record) => record.meta.guest)) {
    if (!store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  }

  next();
});

export default router;
